import { render, staticRenderFns } from "./ConsultaPlantao.vue?vue&type=template&id=8beec900"
import script from "./ConsultaPlantao.vue?vue&type=script&lang=js"
export * from "./ConsultaPlantao.vue?vue&type=script&lang=js"
import style0 from "./ConsultaPlantao.vue?vue&type=style&index=0&id=8beec900&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports